export function MetricCard({ icon: Icon, label, value, color, testId, isDark = true }) {
  return (
    <div className={`p-4 rounded-lg border ${isDark ? 'bg-[#0c0c16] border-white/10' : 'bg-gray-50 border-gray-200'}`} data-testid={testId}>
      <div className="flex items-center gap-2 mb-1">
        <Icon size={16} style={{ color }} />
        <span className={`text-xs font-body ${isDark ? 'text-gray-500' : 'text-gray-400'}`}>{label}</span>
      </div>
      <p className="text-lg font-bold" style={{ color }}>{value}</p>
    </div>
  );
}
